"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.catalogues = void 0;
exports.flattenKeys = flattenKeys;
exports.translate = translate;
const en_json_1 = __importDefault(require("./en.json"));
const uk_json_1 = __importDefault(require("./uk.json"));
exports.catalogues = { uk: uk_json_1.default, en: en_json_1.default };
function flattenKeys(catalogue, prefix = '') {
    return Object.entries(catalogue).flatMap(([key, value]) => {
        const path = prefix ? `${prefix}.${key}` : key;
        return typeof value === 'string' ? [path] : flattenKeys(value, path);
    });
}
function lookup(catalogue, key) {
    let node = catalogue;
    for (const part of key.split('.')) {
        if (node === undefined || typeof node === 'string' || !Object.hasOwn(node, part))
            return undefined;
        node = node[part];
    }
    return typeof node === 'string' ? node : undefined;
}
/** Looks up `key` in the locale catalogue and replaces `{param}` placeholders. */
function translate(locale, key, params = {}) {
    const message = lookup(exports.catalogues[locale], key);
    if (message === undefined)
        return key;
    return message.replace(/\{(\w+)\}/g, (_, name) => String(params[name] ?? `{${name}}`));
}
//# sourceMappingURL=index.js.map